import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { currentPageActions, PageDataSlice } from '~/behaviors/actions/currentPage.actions';

export interface CurrentPageState {
  [key: string]: PageDataSlice;
}

const defaultState: CurrentPageState = {};

const reset = () => defaultState;

const updateCurrentPageData = (state: CurrentPageState, action: PayloadAction<PageDataSlice>) => ({
  ...state,
  [action.payload.cacheKey]: action.payload,
});

const clearCurrentPageData = (state: CurrentPageState, action: PayloadAction<string>) => {
  if (state?.[action.payload]) {
    delete state[action.payload];
  }
};

const currentPage = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(currentPageActions.setPageDataSlice, updateCurrentPageData)
    .addCase(currentPageActions.clearPageDataSlice, clearCurrentPageData);
});

export { currentPage };
